import React from "react";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import "./style.css";
import { useNavigate } from "react-router";
import { LOGIN_PAGE } from "../../routes";
import { SubmitHandler, useForm } from "react-hook-form";
import { emailValidator } from "../../../utils/formsValidation";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { REMIND_PASSWORD_USER_URL } from "../../api/apiRoutes";
import { useDispatch } from "react-redux";
import { setSuccessMessage } from "../../store/alerts/alertsActions";
import FormInput from "../../../utils/FormInput";
import useFacility from "../../../utils/hooks/useFacility";

type Inputs = {
  email: string;
};

const RemindPass: React.FC = () => {
  const isDesktop = useDesktopSize();
  const navigate = useNavigate();
  const { post } = useApiRequest();
  const facilityIds = useFacility();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();
  const handleRemindPass: SubmitHandler<Inputs> = async (data) => {
    const { isError } = await post(REMIND_PASSWORD_USER_URL(facilityIds), { email: data.email });
    if (!isError) {
      dispatch(setSuccessMessage("Hasło zostało wysłane na podany adres email"));
    }
  };

  return (
    <div className={isDesktop ? "login-wrapper" : "login-wrapper-mobile"}>
      <div className={isDesktop ? "login-panel" : "login-panel-mobile"}>
        <form onSubmit={handleSubmit(handleRemindPass)}>
          <h3 className={"remind-panel-title"}>Zapomniałem hasła</h3>
          <p className={"remind-panel-section-1"}>
            Podaj adres email podany przy rejestracji, na który zostanie przesłane nowe hasło
          </p>
          <FormInput
            type={"text"}
            name={"email"}
            text={"E-mail"}
            register={{ ...register("email", { ...emailValidator(true) }) }}
            errors={errors}
          />
          <div className={"div-buttons"}>
            <input className={"login-button"} type={"submit"} value={"Resetuj hasło"} />
            <span>lub</span>
            <button className={"register-button"} onClick={() => navigate(LOGIN_PAGE)}>
              Zaloguj się
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RemindPass;
